export default __webpack_public_path__ + "static/training_0-34c505e6d0b6dd522dbfd46ce308efd6.svg";